module.exports = __webpack_public_path__ + "static/media/layout4.8f2e513c.jpg";